<template>
  <section class="help">
    <div class="content">
      <div class="text">
        <h3>{{ $t("Do you need advice") }}?</h3>
        <p>{{ $t("We are here for you") }}: {{ $t("Mon-Fri") }}</p>
        <strong v-if="language.phone">
          <a :href="`tel:${language.phone}`">{{ language.phone }}</a>
        </strong>
        <strong>
          <a :href="`mailto:${language.email}`">{{ language.email }}</a>
        </strong>
      </div>

      <DiscountBanner />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import DiscountBanner from '../../product/partials/DiscountBanner.vue'

export default {
  components: {
    DiscountBanner,
  },
  computed: {
    ...mapGetters({
      language: 'cart/getLanguage',
    }),
  },
}
</script>
